import { useState, useEffect, useMemo } from 'react';
import { api } from '../api';
import toast from 'react-hot-toast';
import NavIcon from '../components/NavIcon';
import { confirmDialog } from '../components/ConfirmDialog';

function Modal({ sup, onClose, onSave }) {
  const [form, setForm] = useState(sup || { name: '', phone: '', address: '' });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const save = async () => {
    if (!form.name.trim()) return toast.error('Name is required');
    try {
      if (sup?.id) await api.updateSupplier(sup.id, form);
      else await api.createSupplier(form);
      toast.success(sup?.id ? 'Supplier updated' : 'Supplier added'); onSave();
    } catch { toast.error('Failed to save'); }
  };
  return (
    <div className="modal-overlay"><div className="modal">
      <div className="modal-header"><h3>{sup?.id ? 'Edit Supplier' : 'New Supplier'}</h3><button className="btn btn-secondary btn-sm" onClick={onClose}>✕</button></div>
      <div className="form-row">
        <div className="field"><label>Supplier Name *</label><input value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. General Traders" /></div>
        <div className="field"><label>Phone</label><input value={form.phone || ''} onChange={e => set('phone', e.target.value)} placeholder="98XXXXXXXX" /></div>
      </div>
      <div className="field"><label>Address</label><textarea value={form.address || ''} onChange={e => set('address', e.target.value)} rows={2} placeholder="Supplier address" /></div>
      <div className="modal-footer"><button className="btn btn-secondary" onClick={onClose}>Cancel</button><button className="btn btn-primary" onClick={save}>Save Supplier</button></div>
    </div></div>
  );
}

export default function Suppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [modal, setModal]         = useState(null);
  const [search, setSearch]       = useState('');

  const load = () => api.getSuppliers().then(setSuppliers);
  useEffect(() => { load(); }, []);

  const filtered = useMemo(() =>
    suppliers.filter(s => !search ||
      s.name.toLowerCase().includes(search.toLowerCase()) ||
      (s.phone || '').includes(search) ||
      (s.address || '').toLowerCase().includes(search.toLowerCase())),
    [suppliers, search]
  );

  const del = async (s) => {
    if (!(await confirmDialog(`Delete "${s.name}"?`, { danger: true, confirmText: 'Delete' }))) return;
    try { await api.deleteSupplier(s.id); toast.success('Deleted'); load(); }
    catch { toast.error('Failed to delete'); }
  };

  return (
    <div>
      <div className="flex-between mb-6">
        <div className="page-header" style={{margin:0}}><h2>Suppliers</h2><p>Manage your product suppliers</p></div>
        <button className="btn btn-primary" onClick={() => setModal('new')}>+ Add Supplier</button>
      </div>
      <div className="card">
        <div className="filter-bar">
          <input placeholder="Search by name, phone or address…" value={search} onChange={e => setSearch(e.target.value)} />
          <div className="filter-spacer"/>
          <span className="filter-results">{filtered.length} of {suppliers.length} suppliers</span>
        </div>
        {filtered.length === 0 ? (
          <div className="empty-state"><div className="icon"><NavIcon name="suppliers" size={32} /></div><div>No suppliers found.</div></div>
        ) : (
          <div className="table-wrap"><table>
            <thead><tr><th>#</th><th>Name</th><th>Phone</th><th>Address</th><th></th></tr></thead>
            <tbody>
              {filtered.map(s => (
                <tr key={s.id}>
                  <td className="mono text-muted" data-label="#">{s.id}</td>
                  <td style={{fontWeight:600}} data-label="Name">{s.name}</td>
                  <td className="mono" data-label="Phone">{s.phone || '—'}</td>
                  <td className="text-muted" data-label="Address">{s.address || '—'}</td>
                  <td data-label=""><div className="flex gap-2">
                    <button className="btn btn-secondary btn-sm" onClick={() => setModal(s)}>Edit</button>
                    <button className="btn btn-danger btn-sm" onClick={() => del(s)}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
      </div>
      {modal && <Modal sup={modal === 'new' ? null : modal} onClose={() => setModal(null)} onSave={() => { setModal(null); load(); }} />}
    </div>
  );
}
